var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackLogoIcon = function SvgSlackLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M13.934 0a2.2 2.2 0 1 1 0 4.4h-2.201V2.2C11.732.987 12.717.002 13.934 0m0 5.867H19.8a2.2 2.2 0 0 1 0 4.4h-5.866a2.2 2.2 0 1 1 0-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M0 8.066a2.2 2.2 0 0 1 4.401 0v2.2h-2.2a2.2 2.2 0 0 1-2.2-2.2m5.867 0V2.2a2.2 2.2 0 0 1 4.4 0v5.866a2.2 2.2 0 1 1-4.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M8.067 22a2.2 2.2 0 1 1 0-4.399h2.2v2.2a2.2 2.2 0 0 1-2.2 2.2m0-5.867H2.2a2.2 2.2 0 0 1 0-4.4h5.866a2.2 2.2 0 0 1 .001 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M22 13.933a2.2 2.2 0 0 1-4.4 0v-2.2h2.2a2.2 2.2 0 0 1 2.2 2.2m-5.866 0v5.866a2.2 2.2 0 0 1-4.4.001v-5.865a2.2 2.2 0 0 1 4.4-.002"
  }))));
};
export default SvgSlackLogoIcon;